module.exports = __webpack_public_path__ + "img/login-left.810fb798.png";